import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VuejsDialog from 'vuejs-dialog';
import Vuelidate from 'vuelidate';
import VueMomentLib from 'vue-moment-lib';
import Paginate from 'vuejs-paginate';
import VModal from 'vue-js-modal';


Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(VueMomentLib);
Vue.component('paginate', Paginate)

Vue.use(VModal)

Vue.use(VuejsDialog,{
  html: true,
  loader: true,
  okText: 'Evet',
  cancelText: 'Hayır',
  // animation: 'bounce',
  message:'Emin misiniz?'
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
